import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { NoEntriesTableRow } from "components/shared/views/TableView/components/NoEntriesTableRow";
import ACHTransfersFromTableRow from "components/shared/widgets/ACHWidgets/ACHTransfersFromTableRow";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function ACHTransfersFromTable
 * @return {React.Component}
 * @exported true
 * @description - This is the "One Time ACH From" main table view for the OneTimeACHPaymentPage.
 */
export default function ACHTransfersFromTable(props) {
    const achFromAccounts = props.achFromAccounts ?? [];
    const onACHFromAccountChange = props.onACHFromAccountChange ?? (() => {});
    const onACHFromAccountDelete = props.onACHFromAccountDelete ?? (() => {});

    const rows = achFromAccounts.accounts.reduce((acc, item) => {
        acc.push(
            <ACHTransfersFromTableRow key={ item.id } achFromAccount={ item } onACHFromAccountChange={ onACHFromAccountChange } 
            onACHFromAccountDelete={ onACHFromAccountDelete } dataPoint={ `One_Time_ACH_From_Row_${ item.id }`} />
        );
        return acc;
    }, []);
    const hasRows = rows.length > 0;
    
    return (
        <TableView className="one-time-ach-from-table">
            <TableColumnContainer className="one-time-ach-from-header">
                <TableItemView lassName="nickname-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Nickname</span>
                        <DisabledPrompt>
                            <SVGAsset id="SortIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                <TableItemTextView className="account-number-col" text="Account Number" />
                <TableItemView lassName="account-type-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Account Type</span>
                        <DisabledPrompt>
                            <SVGAsset id="SortIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                <TableItemTextView className="amount-col" text="Amount" />
                <TableItemTextView className="trash-can-col" />
            </TableColumnContainer>
            <TableBody>
              { !hasRows && <NoEntriesTableRow colSpan={8}/> }
              { hasRows && rows }
            </TableBody>
        </TableView>
    )
}
